import {ReactNode, useState} from 'react';
import {
  ArticleMultilayerPlan,
  ArticleMultilayerPlanModel,
} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan.models';
import {ArticleSpecification} from '../../envisia/article/models/article-specification.model';
import {ArticleMultilayerPlanForm} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan-form';
import {
  ArticleMultilayerSelect,
} from '../../envisia/article/main/multilayer-plan/form-elements/article-multilayer-select.component';
import {ArticleMultilayerPlanHelper} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan-helper';
import {useMultilayerPlanCreateMutation} from './use-multilayer-plan-create-mutation';
import {useMultilayerPlanUpdateMutation} from './use-multilayer-plan-update-mutation';
import Helper from '../../helper/helper';
import {
  ArticleMultilayerSaveErrorModal,
} from '../../envisia/article/main/multilayer-plan/modal/article-multilayer-save-error-modal';

interface Props {
  specification: { [key: string]: ArticleSpecification };
  model: ArticleMultilayerPlan | null;
  selection: (sharedId: string | null) => void;
  children?: ReactNode;
}

export function MultilayerPlanForm(props: Props) {
  const [state, setState] = useState<{
    model: ArticleMultilayerPlanModel,
    selected: ArticleMultilayerPlan | null,
  }>({
    model: props.model?.data ?? ArticleMultilayerPlanHelper.emptyModel(),
    selected: props.model ?? null,
  });

  const {createMutation, createIsPending, createError, createReset} = useMultilayerPlanCreateMutation({
    form: state.model,
    selection: (sharedId) => props.selection(sharedId),
  });

  const {updateMutation, updateIsPending, updateError, updateReset} = useMultilayerPlanUpdateMutation({
    form: state.model,
    sharedId: state.selected?.shared_id,
  });

  const save: () => void = () => {
    if (state.selected === null) {
      createMutation();
    } else {
      updateMutation();
    }
  };

  const modelChanged: (model: ArticleMultilayerPlanModel) => void = (m) => {
    setState({
      ...state,
      model: ArticleMultilayerPlanHelper.recalculate({
        ...ArticleMultilayerPlanHelper.copy(state.model),
        ...m,
      }),
    });
  };

  const materialChanged: (m: string | null | undefined) => void = (m) => {
    setState({
      ...state,
      model: ArticleMultilayerPlanHelper.recalculate({
        ...ArticleMultilayerPlanHelper.copy(state.model),
        selected_material: !m ? 'Standard FR4' : m,
      }),
    });
  };

  return <>
    <ArticleMultilayerSaveErrorModal error={createError ?? updateError}
                                     closed={() => {
                                       createReset();
                                       updateReset();
                                     }}/>

    <div className="buttonbar-view">
      &nbsp;
      <button type="button"
              className="btn btn-default"
              title="Multilayer Plan erstellen"
              onClick={() => props.selection(null)}>
        <span className="fa fa-plus"/>
      </button>

      <button type="button"
              className="btn btn-default"
              title="Artikel speichern"
              disabled={createIsPending || updateIsPending}
              onClick={() => save()}>
        Speichern
      </button>
    </div>

    <div className="row">
      <div className="col-lg-9">
        <ArticleMultilayerPlanForm model={state.model}
                                   specification={props.specification}
                                   changeModel={modelChanged}>
          <ArticleMultilayerSelect specification={props.specification}
                                   model="manufacturer"
                                   valueType="keys"
                                   value={state.model.selected_material}
                                   disabled={Helper.undefined(state.model.parts)}
                                   onChange={materialChanged}/>
        </ArticleMultilayerPlanForm>
      </div>
      <div className="col-lg-3">
        {props.children}
      </div>
    </div>
  </>;
}
